module.exports = __webpack_public_path__ + "media/src/images/landing_icons/landing_features-02-f483c84eff1f79f701fdc80b73b20d58.svg";